<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box" v-if='targettype === 1'>
				<span>商品类别：</span>
				<el-select v-model="smallTypeCategory" filterable clearable class="name-input" size='mini'>
					<el-option
						v-for="item in options"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>运输方式：</span>
				<el-select v-model="transportMode" size='mini' clearable>
					<el-option :value='1' label="常温运输"></el-option>
					<el-option :value='2' label="冷链运输"></el-option>
				</el-select>
			</div>
			<div class="input-box" style="margin: 0 10px;">
				<el-input
					v-model="name"
					placeholder="请输入商品信息"
					size="mini"
					>
					<el-button style="background-color: var(--fx-primary-color);color: #fff;" slot="append" size="mini" type="primary" @click="search" icon="el-icon-search"></el-button>
				</el-input>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					@click="search">查询</el-button>
			</div>
			<div class="input-box-btn">
				<el-button
					class="search-btn"
					size="mini"
					plain
					@click="reset">清空</el-button>
			</div>
			<div class="input-box-btn" style="width:120px">
				<el-button type="primary" size="mini" v-if="!showCheckFlag" plain @click="showCheck(true)">查看选中商品</el-button>
				<el-button type="primary" size="mini" v-if="showCheckFlag" plain @click="showCheck(false)">查看全部商品</el-button>
			</div>
		</div>
        <div class="table-box">
			<el-table
					ref="multipleTable"
                    class="grid-content"
                    size='mini'
                    :data="tableData"
                    :height="tableHeight"
					border
					stripe
					@select="selectionChangeHandle"
					@select-all="selectionChangeHandle">
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					prop="productName"
					label="商品名称"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="商品类别"
					align="center"
					min-width="150">
				</el-table-column>
				<el-table-column
					prop="transportMode"
					label="运输方式"
					align="center"
					min-width="150">
					<template slot-scope="scope">
						<span v-if="scope.row.transportMode === 1">常温运输</span>
						<span v-if="scope.row.transportMode === 2">冷链运输</span>
					</template>
				</el-table-column>
                <el-table-column
					prop="price"
					label="销售价格"
					align="center"
					min-width="150">
				</el-table-column>
                <!-- <el-table-column
					prop="unSaleFlag"
					label="可售状态"
					align="center"
					min-width="150">
				</el-table-column> -->
				<el-table-column
					prop="stopFlag"
					label="启用状态"
					align="center"
					min-width="150">
				</el-table-column>
			</el-table>
        </div>
		<div style="text-align:right;height: 40px;">
			<el-pagination
				v-if="!showCheckFlag"
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="pagination.page"
				:page-sizes="[20, 40, 60, 100, 300]"
				:page-size="pagination.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalCount">
			</el-pagination>
		</div>
         <div class="binding-foot">
            <el-button class="btn" size='small' @click="cancelClick">取消</el-button>
            <el-button  class="btn" size='small' type="primary" @click="bindClick">添加</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'addProduct',
	props: {
		ids: Array,
		targettype: Number
	},
	data () {
		return {
			transportMode: null,
			showCheckFlag: false,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'productAttrplanId'
			}),
			pagination: {
				page: 1,
				size: 20
			},
			totalCount: 0,
			smallTypeCategory: '',
			options: [],
			isLoad: true,
			name: '',
			tableData: [],
			allCheck: [],
			tableHeight: '100%',
			bigcategoryview: 0
		}
	},
	created () {
		this.checkSmallCategory()
		this.getCategory()
		this.tableReload()
	},
	methods: {
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		showCheck (flag) {
			this.showCheckFlag = flag
			this.productPagination = {
				page: 1,
				size: 20
			}
			if (flag) {
				this.allCheck = this.tableSelectUtils.getSelectRows()
				this.searchTable()
			} else {
				this.tableReload()
			}
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.tableReload()
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.tableReload()
		},
		reset () {
			this.tableData = []
			this.name = ''
			this.smallTypeCategory = ''
			this.pagination = {
				page: 1,
				size: 20
			}
			if (this.showCheckFlag) {
				this.searchTable()
			} else {
				this.tableReload()
			}
		},
		search () {
			this.pagination = {
				page: 1,
				size: 20
			}
			this.tableData = []
			if (this.showCheckFlag) {
				this.searchTable()
			} else {
				this.tableReload()
			}
		},
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.options = res.data
			})
		},
		selectionChangeHandle (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.allCheck = this.tableSelectUtils.getSelectRows()
			if (this.showCheckFlag) {
				this.searchTable()
			}
		},
		searchTable () {
			let smallTypeCategory = this.smallTypeCategory
			let productname = this.name
			let arr = []
			this.allCheck.forEach(item => {
				let flag = true
				if (smallTypeCategory !== '') {
					let itemTypeCategory = this.bigcategoryview === 1 ? item.scId : item.bcId
					if (itemTypeCategory !== smallTypeCategory) {
						flag = flag && false
					}
				}
				if (productname !== '') {
					if (item.productName.indexOf(productname) === -1) {
						flag = flag && false
					}
				}
				if (flag) {
					arr.push(item)
				}
			})
			this.tableData = arr
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
			})
		},
		tableReload () {
			let params = {
				transportMode: this.transportMode,
				attrplanIds: this.ids,
				productName: this.name,
				smallTypeCategory: this.smallTypeCategory,
				size: this.pagination.size,
				page: this.pagination.page
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/productAttrplan/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					res.data.list.forEach(e => {
						e.stopFlag = e.stopFlag === 0 ? '启用' : '停用'
						e.unSaleFlag = e.unSaleFlag === 0 ? '可售' : '停售'
						e.price = e.price === -1 ? '' : this.$fxUtils.toFixedSHW(e.price, 2)
						e.categoryName = e.bcName + (e.scName ? '-' + e.scName : '')
					})
					this.totalCount = res.data.count
					this.tableData = res.data.list
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelClick () {
			this.$emit('cancel', true)
		},
		bindClick () {
			let checkArr = this.tableSelectUtils.getSelectRows()
			if (checkArr.length === 0) {
				this.$message.error('请选择商品')
				return false
			}
			this.$emit('add', checkArr)
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :100%;
	flex-direction: column;
    height :500px;
    overflow-y :auto;
	.search-box{
        text-align :left;
		width:100%;
		min-height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :70px;
		}
		.input-box{
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
    .table-box{
		width :100%;
		margin-top:10px;
        padding-bottom :10px;
        height:calc(100% - 135px);
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		text-align :right;
        margin-top :10px;
        width :100%
    }
}
</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
